import { render } from "./DecoratorDiagramComponent.vue?vue&type=template&id=7d3d6ece&scoped=true"
const script = {}

import "./DecoratorDiagramComponent.vue?vue&type=style&index=0&id=7d3d6ece&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d3d6ece"]])

export default __exports__